import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import InfoBlock from '@components/common/info_block';

const DeleteApiKeyWebhooksModal = () => {
    const { t } = useTranslation('modals', {
        keyPrefix: 'delete_account'
    });

    return (
        <div className={styles.wrapper}>
            <Typography className={styles.title} variant="h4">
                Delete webhook
            </Typography>
            <Typography variant="body2" alignment="center">
                Are you sure you want to delete this webhook?
            </Typography>
            <InfoBlock variant="error">
                Please note: Deleting this webhook will stop all event notifications for this
                endpoint.
            </InfoBlock>
        </div>
    );
};

export default DeleteApiKeyWebhooksModal;
